import { DrawingWCNationalTeamBaskets } from "./drawing-national-team-baskets";

export class DrawingWCFinalRequestDto {
    nat: DrawingWCNationalTeamBaskets;
    u21: DrawingWCNationalTeamBaskets;
    mds: number[];
}